import { useContext } from 'react';
import { AppContext } from '@send-legacy-app/Context';

const useLoading = () => {
  const { loading } = useContext(AppContext);
  return [loading];
};

export default useLoading;
